import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { TooltipWithErrorBoundary as Tooltip, TooltipConstants, removeClickable } from '@Components/Tooltip';
import { placeBottomAlignRight } from '@Pages/Heatmap/HeatmapTooltipHeaders/tooltipOverridePosition';
import { getOptionsTooltipContent } from '@Pages/Heatmap/HeatmapTooltipHeaders/getTooltipContent';
import { TooltipEvents } from './constants';

function HeatmapTooltipHeadersOptionsCols({ params, dataMap, type }) {
  const onClose = useCallback(() => {
    removeClickable(TooltipConstants.ids.HeatmapTooltipHeadersOptionsCols);
    TooltipEvents.hideOnClickTooltips();
  }, []);

  return (
    <Tooltip
      id={TooltipConstants.ids.HeatmapTooltipHeadersOptionsCols}
      elsTooltip={false}
      className="heatmap-tooltip rs-tooltip-big"
      place="bottom"
      overridePosition={placeBottomAlignRight}
      getContent={(index) => (index ? getOptionsTooltipContent({ params, data: dataMap[index], type, isRow: false, onClose }) : null)}
      hideDelay={100}
      globalEventOff={TooltipEvents.ON_CLICK_EVENT}
      clickable
      afterShow={TooltipEvents.hideOnHoverTooltips}
      isCapture
    />
  );
}

HeatmapTooltipHeadersOptionsCols.propTypes = {
  params: PropTypes.object.isRequired,
  dataMap: PropTypes.object,
  type: PropTypes.string,
};

export default HeatmapTooltipHeadersOptionsCols;
